import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  list: [],
  pageInfo: {
    page: 1,
    totalPage: 2
  },
  condition: {
    userNo: 0,
    page: 1,
    limit: 10,
    storeNo: '',
    storeTypeNo: null,
    storeCategoryNo: null,
    searchText: '',
    regDate: '',
    startDate: '',
    endDate: ''
  },
  detail: {
    productNo:0,
    productCategoryNo:0,
    storeNo:0,
    originNo:0,
    nameKr:'',
    nameVn:'',
    contentKr:'',
    contentVn:'',
    tagKr:'',
    tagVn:'',
    barcode:'',
    price:0,
    discountRate:0.0,
    isOrderable:false,
    isShow:true,
    isActive:true,
    isManageStock:false,
    stock:0,
    isR18:false,
    isRepresentative:false,
    isRepresentativeOrder:0,
    optionGroups:[],
    file:{
      storedFileName: ''
    },
    rawFile:null
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
